export const addGirvi = async (girviData) => {
    const response = await fetch(process.env.REACT_APP_API_URL, {
        method: "POST",
        body: JSON.stringify({action: "addGirvi", apiKey: process.env.REACT_APP_API_KEY, origin: window.location.origin, ...girviData})
    });
    const jsonResponse = await response.json();
    if (jsonResponse?.success === true) {
        let data = girviData;
        data.id = jsonResponse?.data?.id;
        jsonResponse.data = data;
    }
    console.log('Add Girvi Response:', response);
    return jsonResponse;
};
export const updateGirvi = async (girviId, girviData) => {
    const response = await fetch(process.env.REACT_APP_API_URL, {
        method: "POST",
        body: JSON.stringify({action: "updateGirvi", apiKey: process.env.REACT_APP_API_KEY, origin: window.location.origin, id: girviId, ...girviData})
    });
    const jsonResponse = await response.json();
    if (jsonResponse?.success === true) {
        let data = girviData;
        data.id = girviId;
        jsonResponse.data = data;
    }
    console.log('Update Girvi Response:', response);
    return jsonResponse;
};
export const deleteGirvi = async (girviId) => {
    const response = await fetch(process.env.REACT_APP_API_URL, {
        method: "POST",
        body: JSON.stringify({action: "deleteGirvi", apiKey: process.env.REACT_APP_API_KEY, origin: window.location.origin, id: girviId})
    });
    return await response.json();
};
